import React, { createContext, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";

const InitialRouteContext = createContext(null);

export function InitialRouteProvider({ children }) {
  const location = useLocation();
  const initialPathRef = useRef(null);
  if (initialPathRef.current === null) {
    initialPathRef.current = location.pathname;
  }
  return (
    <InitialRouteContext.Provider value={initialPathRef.current}>
      {children}
    </InitialRouteContext.Provider>
  );
}

export function useInitialPathname() {
  return useContext(InitialRouteContext);
}
